/** Singular store link: one destination for both app stores. */
export const APP_DOWNLOAD_URL = "https://spond.sng.link/D472x/4fzw?_smtype=3";
